import { FC, PropsWithChildren, useMemo } from 'react';
import { FlagProvider } from '@unleash/proxy-client-react';
import { useAuth0 } from '@auth0/auth0-react';
import { useAppSelector } from './redux/hooks';
import { selectUser } from './redux/reducers/userSlice';

export const UnleashProvider: FC<PropsWithChildren> = ({ children }) => {
  const { user } = useAuth0();
  const userRedux = useAppSelector(selectUser);
  const unleashURL = import.meta.env.VITE_UNLEASH_URL;
  const unleashClientKey = import.meta.env.VITE_UNLEASH_CLIENT_KEY;
  const unleashEnabled = import.meta.env.VITE_UNLEASH_ENABLED !== 'false';
  const startUnleashClient = unleashEnabled && Boolean(unleashURL && unleashClientKey);

  if (unleashEnabled && !startUnleashClient) {
    console.warn('Unleash URL (feature flagging) or client key is not set in the environment variables.');
  }

  const networkId = userRedux?.network?.id ?? '';
  const siteId = userRedux?.sites?.[0]?.id ?? '';

  const config = useMemo(
    () => ({
      url: unleashURL || 'http://localhost:4242/api',
      clientKey: unleashClientKey || 'UNLEASH_CLIENT_KEY_NOT_SET',
      refreshInterval: 15,
      disableMetrics: !startUnleashClient,
      appName: 'roadmaps',
      context: {
        userId: user?.sub,
        properties: { networkId, siteId },
      },
    }),
    [user?.sub, networkId, siteId, startUnleashClient],
  );

  return (
    <FlagProvider config={config} startClient={startUnleashClient}>
      {children}
    </FlagProvider>
  );
};
